"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.L1CategorySelect = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const attributes_matrix_selector_styles_1 = require("./attributes-matrix-selector/attributes-matrix-selector.styles");
const hooks_1 = require("../client/hooks");
const use_get_search_l1_categories_and_terminal_nodes_hook_1 = require("../client/hooks/use-get-search-l1-categories-and-terminal-nodes.hook");
const utils_1 = require("../utils/utils");
const action_select_styles_1 = require("../../generic/action-select/action-select.styles");
const grouped_multi_select_menu_1 = require("../../generic/grouped-multi-select-menu");
const localization_1 = require("../../../localization");
const L1CategorySelect = ({ selectedCategories, selectedCatalogId, onSelect, productTreeRootNodeId, selectedProductTreeId, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const { data: defaultData, isLoading: defaultLoading } = (0, hooks_1.useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix)({
        productTreeNodeId: productTreeRootNodeId,
        catalogId: selectedCatalogId,
        options: {
            skip: !productTreeRootNodeId,
            fetchPolicy: 'cache-first',
        },
    });
    const { data: searchedData, isLoading: searchedLoading, error: searchError, } = (0, use_get_search_l1_categories_and_terminal_nodes_hook_1.useSearchL1CategoriesAndTerminalNodesForStrategyMatrix)({
        productTreeId: selectedProductTreeId,
        searchTerm: searchTerm || '',
    });
    const groupedOptions = (0, react_1.useMemo)(() => (0, utils_1.createGroupedOptions)(defaultData), [defaultData]);
    const derivedSelected = (0, react_1.useMemo)(() => {
        if (selectedCategories.length > 0) {
            return selectedCategories;
        }
        // If no categories are selected but we have grouped options, select all
        if (groupedOptions.length > 0) {
            return groupedOptions.map((o) => (Object.assign(Object.assign({}, o), { allSelected: true })));
        }
        return [];
    }, [selectedCategories, groupedOptions]);
    const displayCount = selectedCategories.length > 0 ? selectedCategories.length : groupedOptions.length;
    const hasSearchResults = !!searchTerm && !searchError;
    const finalData = hasSearchResults ? searchedData : groupedOptions;
    const initialExpandedParentId = hasSearchResults ? (_a = finalData[0]) === null || _a === void 0 ? void 0 : _a.value : undefined;
    const categoriesIsLoading = defaultLoading || searchedLoading;
    const handleApply = (selected) => {
        onSelect(selected);
        setAnchorEl(null);
    };
    const handleSearch = (search) => {
        setSearchTerm(search);
    };
    const isOpen = !!anchorEl;
    return (react_1.default.createElement(attributes_matrix_selector_styles_1.StyledAttributeSection, null, react_1.default.createElement(action_select_styles_1.StyledAction, { color: "primary", title: `${t({ key: 'L1_CATEGORY' })} ${displayCount}`, size: "small", className: (0, classnames_1.default)({ 'menu--open': isOpen }), endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: isOpen ? 'chevronUp' : 'chevronDown' }), onClick: (event) => setAnchorEl(event.currentTarget) }), react_1.default.createElement(grouped_multi_select_menu_1.GroupedMultiSelectMenu, { anchorEl: anchorEl, isLoading: categoriesIsLoading, groupedOptions: finalData, initialExpandedParentId: initialExpandedParentId, selected: derivedSelected, onApply: handleApply, onClose: () => setAnchorEl(null), onSearch: handleSearch })));
};
exports.L1CategorySelect = L1CategorySelect;
exports.default = exports.L1CategorySelect;
